import { Environment } from '@app/shared/models';

export const environment: Environment = {
  production: false,
  api_url: 'https://incroco-api.ipink.com.ar',
  features: {
    enableSSR: true,
    enableDevTools: true,
  }
}
